// File: src/data/Products1.js
import cImg from '../assets/images/c.jpg';
import dImg from '../assets/images/damper.png';
import bImg from '../assets/images/convey.png';
import aImg from '../assets/images/Mesh.png';


const Products1 = [
  { id: 1, name: "Crusher Spare Parts", image: cImg, type: "Crusher" },
  { id: 2, name: "Stopper,Damper", image: dImg, type: "Stopper" },
  { id: 3, name: "Conveyor,Roller", image: bImg, type: "Conveyor" },
  { id: 5, name: "Mesh", image: aImg, type: "Mesh" },
];

export default Products1;

